<template>
  <div v-if="hasActions">
    <VcDropdown
      v-model="isOpen"
      :data-qa="dataQa"
      class="ai-dropdown-content"
      content-class="ai-dropdown-content"
      :contentAreaStyle="$vuetify.breakpoint.mdAndUp ? 'maxWidth: 272px; scrollbar-width: none;' : ''"
    >
      <template #activator="{ on, attrs }">
        <VcButton v-bind="attrs" small icon v-on="on" data-qa="VcButton" class="dropdown-button">
          <template #prepend>
            <VcIcon color="blue" size="16">icon-AI-Sparkles</VcIcon>
          </template>
        </VcButton>
      </template>
      <template>
        <VcLayout column>
          <VcAlert
            data-qa="VcAlert"
            type="recommendation"
            :body-text="bodyText"
            :buttons-data="buttonsData"
            @action0="onActionClick"
            @action1="onActionClick"
            @action2="onActionClick"
          />
        </VcLayout>
      </template>
    </VcDropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AiDropdown',
  props: {
    dataQa: {
      type: String,
      default: 'ai-dropdown',
    },
    bodyText: {
      type: String,
    },
    matterUid: {
      type: String,
      required: false,
    },
    client: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters('BizaiStore', ['clientRecommendations']),
    actions() {
      return this.clientRecommendations[this.matterUid] || [];
    },
    hasActions() {
      return this.actions.length;
    },
    buttonsData() {
      return this.actions.map((action) => ({
        label: action.display.btn_text,
        dataQa: `VcAlert-action-ai-${action.action}`,
        data: action,
      }));
    },
  },
  methods: {
    onActionClick(action) {
      this.isOpen = false;
      this.$emit('action-selected', action.data, this.client);
    },
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        this.$track('AI Recommendation Action Click', { action_type: 'click', location: 'Dashboard' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-button {
  background-image: linear-gradient(180deg, var(--ai-surface-top) 0%, var(--ai-surface-bottom) 100%)
}
</style>
